import { PersistentFormGroup } from '@utility/persistent-forms';
import { SiteServicesPatientPaceOptionsFormGroup } from './site-services-patient-pace-options/site-services-patient-pace-options.form';
import { SiteServicesPaymentOptionsFormGroup } from './site-services-payment-options/site-services-payment-options.form';
import { SiteServicesPaymentValidationFormGroup } from './site-services-payment-validation/site-services-payment-validation.form';
import { SiteServicesSpecificServicesFormGroup } from './site-services-specific-services/site-services-specific-services.form';

export class SiteServicesFormGroup extends PersistentFormGroup<{
    readyForPaymentValidationFormGroup: SiteServicesPaymentValidationFormGroup;
    specificServices: SiteServicesSpecificServicesFormGroup;
    paymentOptions: SiteServicesPaymentOptionsFormGroup;
    patientPaceOptions: SiteServicesPatientPaceOptionsFormGroup;
}> {
    constructor() {
        super({
            readyForPaymentValidationFormGroup: new SiteServicesPaymentValidationFormGroup(),
            specificServices: new SiteServicesSpecificServicesFormGroup(),
            paymentOptions: new SiteServicesPaymentOptionsFormGroup(),
            patientPaceOptions: new SiteServicesPatientPaceOptionsFormGroup(),
        });
    }
}
